import { defineComponent } from 'vue';

import { DEFAULT_LAYOUT_SLOT_NAMES } from './default-layout/defaultLayoutSlotNames.const';

/**
 * Vue 2 mixin that provides DEFAULT_LAYOUT_SLOT_NAMES in data().
 *
 * Vue 3 migration: This can be replaced with a composable:
 * ```ts
 * export function useDefaultLayoutSlots() {
 *   return { DEFAULT_LAYOUT_SLOT_NAMES };
 * }
 * ```
 */
export const defaultLayoutSlotForwardingMixin = defineComponent({
    data() {
        return {
            DEFAULT_LAYOUT_SLOT_NAMES,
        };
    },
});

